'use client';

import { useEffect, useRef, useState } from 'react';

interface Props {
  children: React.ReactNode;
  className?: string;
  delay?: number; // ms
}

export default function SlideUp({ children, className = '', delay = 0 }: Props) {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    // threshold: 0 으로 단 1px이라도 교차하면 발화시킨다.
    // 본문이 viewport보다 훨씬 긴 article에선 가시 비율이 threshold(0.1)에 못 미쳐
    // 콜백이 영구히 호출되지 않아 opacity-0이 풀리지 않는 모바일 버그가 있었다.
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          observer.disconnect();
          setTimeout(() => setVisible(true), delay);
        }
      },
      { threshold: 0 },
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, [delay]);

  return (
    <div ref={ref} className={`${className} ${visible ? 'animate-slide-up' : 'opacity-0'}`}>
      {children}
    </div>
  );
}
